import { AddMemberPolaris } from "../components/members/AddMemberPolaris";
import { EditMemberPolaris } from "../components/members/EditMemberPolaris";
import { Clone as CloneProductFromPrintFile } from "../components/product/print-file/Clone";
import { Create as CreateProductFromPrintFile } from "../components/product/print-file/Create";
import { Edit as EditProductFromPrintFile } from "../components/product/print-file/Edit";
import { TemplatesPolaris } from "../components/product/templates/TemplatesPolaris";
import MainLayout from "../layout/MainLayout";
import AddCampaignProduct from "../pages/seller/AddCampaignProduct";
import AddProductPage from "../pages/seller/AddProduct";
import { CloneProduct } from "../pages/seller/CloneProduct";
import { CloneProductCampaign } from "../pages/seller/CloneProductCampaign";
import EditProductPage from "../pages/seller/EditProduct";
import EditProductCampaign from "../pages/seller/EditProductCampaign";
import { IdeaTaskPagePolaris } from "../pages/seller/IdeaTaskPagePolaris";
import { OrdersPagePolaris } from "../pages/seller/OrdersPagePolaris";
import { ProductAssortmentPagePolaris } from "../pages/seller/ProductAssortmentPagePolaris";
import { ProductFromPrintFilePage } from "../pages/seller/ProductFromPrintFilePage";
import { ProductsPagePolaris } from "../pages/seller/ProductsPagePolaris";
import { TeamMembersPagePolaris } from "../pages/seller/TeamMembersPagePolaris";
// import { AddForProduct as AddTemplateForProduct } from "../components/product/templates/AddForProduct";
import { AddForProduct as AddTemplateForProduct } from "../components/product/templates/add-for-product-v2";
import { AddForCampaign as AddTemplateForCampaign } from "../components/product/templates/AddForCampaign";
import { CloneProductV2 } from "../pages/seller/CloneProductV2";
import AddProductPageV2 from "../pages/seller/AddProductV2";
import EditProductPageV2 from "../pages/seller/EditProductV2";
import { OrdersPagePolaris2 } from '../pages/seller/OrdersPagePolaris2';

export default [
  {
    path: "/idea-leader/tasks",
    exact: true,
    component: IdeaTaskPagePolaris,
    title: "Idea Task page",
    layout: MainLayout,
    roles: ["Seller"],
    teamRole: "IdeaLeader",
  },
  {
    path: "/idea-leader/team-members",
    exact: true,
    component: TeamMembersPagePolaris,
    layout: MainLayout,
    title: "Members",
    roles: ["Seller"],
    teamRole: "IdeaLeader",
  },
  {
    path: "/idea-leader/add-team-member",
    exact: true,
    component: AddMemberPolaris,
    layout: MainLayout,
    title: "Add New Member",
    roles: ["Seller"],
    teamRole: "IdeaLeader",
  },
  {
    path: "/idea-leader/edit-team-member/:id",
    exact: true,
    component: EditMemberPolaris,
    layout: MainLayout,
    roles: ["Seller"],
    teamRole: "IdeaLeader",
  },
  {
    path: "/idea-leader/products",
    exact: true,
    component: ProductsPagePolaris,
    layout: MainLayout,
    title: "Products",
    roles: ["Seller"],
    teamRole: "IdeaLeader",
  },
  {
    path: "/idea-leader/orders2",
    exact: true,
    component: OrdersPagePolaris,
    layout: MainLayout,
    title: "Orders",
    roles: ["Seller"],
    teamRole: "IdeaLeader",
  },
  {
    path: "/idea-leader/orders",
    exact: true,
    component: OrdersPagePolaris2,
    layout: MainLayout,
    title: "Orders",
    roles: ["Seller"],
    teamRole: "IdeaLeader",
  },
  {
    path: "/idea-leader/product-assortment",
    exact: true,
    component: ProductAssortmentPagePolaris,
    layout: MainLayout,
    roles: ["Seller"],
    teamRole: "IdeaLeader",
    private: true,
  },
  {
    path: "/idea-leader/products/add",
    exact: true,
    // component: AddProductPage,
    component: AddProductPageV2,
    layout: MainLayout,
    title: "Add Product",
    roles: ["Seller"],
    teamRole: "IdeaLeader",
  },
  {
    path: "/idea-leader/products/add/:id",
    exact: true,
    // component: AddProductPage,
    component: AddProductPageV2,
    layout: MainLayout,
    title: "Add Product",
    roles: ["Seller"],
    teamRole: "IdeaLeader",
  },
  {
    path: "/idea-leader/products/clone",
    exact: true,
    // component: CloneProduct,
    component: CloneProductV2,
    layout: MainLayout,
    title: "Clone Product",
    roles: ["Seller"],
    teamRole: "IdeaLeader",
  },
  {
    path: "/idea-leader/products/add-campaign",
    exact: true,
    component: AddCampaignProduct,
    layout: MainLayout,
    title: "Add Campaign Product",
    roles: ["Seller"],
    teamRole: "IdeaLeader",
  },
  {
    path: "/idea-leader/products/add-campaign/:id",
    exact: true,
    component: AddCampaignProduct,
    layout: MainLayout,
    title: "Add Campaign Product",
    roles: ["Seller"],
    teamRole: "IdeaLeader",
  },
  {
    path: "/idea-leader/products/clone-campaign",
    exact: true,
    component: CloneProductCampaign,
    layout: MainLayout,
    title: "Clone Campaign Product",
    roles: ["Seller"],
    teamRole: "IdeaLeader",
  },
  {
    path: "/idea-leader/products/campaign/:id",
    exact: true,
    component: EditProductCampaign,
    layout: MainLayout,
    title: "Edit Product Campaign",
    roles: ["Seller"],
    teamRole: "IdeaLeader",
  },
  {
    path: "/idea-leader/products/edit/:id",
    exact: true,
    // component: EditProductPage,
    component: EditProductPageV2,
    layout: MainLayout,
    title: "Edit Product",
    roles: ["Seller"],
    teamRole: "IdeaLeader",
  },
  {
    path: "/idea-leader/templates",
    exact: true,
    component: TemplatesPolaris,
    layout: MainLayout,
    title: "Templates",
    roles: ["Seller"],
    teamRole: "IdeaLeader",
  },
  {
    path: "/idea-leader/product-from-print-file",
    exact: true,
    component: ProductFromPrintFilePage,
    title: "Product From Print File Page",
    layout: MainLayout,
    roles: ["Seller"],
    teamRole: "IdeaLeader",
    private: true,
  },
  {
    path: "/idea-leader/product-from-print-file/create",
    exact: true,
    component: CreateProductFromPrintFile,
    title: "Create Product From Print File Page",
    layout: MainLayout,
    roles: ["Seller"],
    teamRole: "IdeaLeader",
    private: true,
  },
  {
    path: "/idea-leader/product-from-print-file/edit/:id",
    exact: true,
    component: EditProductFromPrintFile,
    title: "Edit Product From Print File Page",
    layout: MainLayout,
    roles: ["Seller"],
    teamRole: "IdeaLeader",
    private: true,
  },
  {
    path: "/idea-leader/product-from-print-file/clone/:id",
    exact: true,
    component: CloneProductFromPrintFile,
    title: "Clone Product From Print File Page",
    layout: MainLayout,
    roles: ["Seller"],
    teamRole: "IdeaLeader",
    private: true,
  },
  {
    path: "/idea-leader/templates/for-product",
    exact: true,
    component: AddTemplateForProduct,
    layout: MainLayout,
    title: "Add Template for Product",
    roles: ["Seller"],
    teamRole: "IdeaLeader",
  },
  {
    path: "/idea-leader/templates/for-campaign",
    exact: true,
    component: AddTemplateForCampaign,
    layout: MainLayout,
    title: "Add Template for Campaign",
    roles: ["Seller"],
    teamRole: "IdeaLeader",
  },
];
